import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Chip, Stack, Box, Paper } from '@mui/material';

// Pass this as a prop or fetch from API


const groupSlotsByDay = (slots) => {
    const map = new Map();

    slots.forEach((slot) => {
        const date = new Date(slot.startTimeUtc);
        const dateKey = date.toDateString(); // e.g., "Sun May 25 2025"

        if (!map.has(dateKey)) {
            map.set(dateKey, []);
        }
        map.get(dateKey).push(slot);
    });

    return Array.from(map.entries()).map(([fullDate, slots]) => {
        const dateObj = new Date(slots[0].startTimeUtc);
        return {
            day: dateObj.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
            date: dateObj.getDate(),
            fullDate,
            slots,
        };
    });
};

const handleTimeClick = (day, time) => {
    console.log(`You clicked ${time} on ${day}`);
    // You can call a function here to select a slot, open a modal, etc.
};

const ScheduleViewer = ({ availableSlots, gender, age, fullName, problem, handleSlotClick, bookingPayload }) => {
    console.log('Available Slots:', availableSlots);
    const daysWithSlots = groupSlotsByDay(availableSlots);

   

    //   useEffect(() => { 
    //     groupSlotsByDay(availableSlots)
    //   }, [availableSlots]);

    const formatTime = (start, end) => {
        const startTime = new Date(start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const endTime = new Date(end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return `${startTime} - ${endTime}`;
    };

    return (
        <Box sx={{ maxHeight: 400, overflowY: 'auto', p: 2, bgcolor: '#f7f7f7', borderRadius: 2 }}>
            <Stack spacing={2}>
                {daysWithSlots.map((day, idx) => (
                    <Card key={idx} variant="outlined" sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Typography variant="subtitle2" color="text.secondary">
                                {day.fullDate}
                            </Typography>
                            <Typography variant="h6" fontWeight="bold" gutterBottom>
                                {day.day}, {day.date}
                            </Typography>
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                {day.slots.map((slot, i) => {
                                    const isSelected = bookingPayload?.slotId === slot.id;

                                    return (
                                        <Chip
                                            key={i}
                                            label={formatTime(slot.startTimeUtc, slot.endTimeUtc)}
                                            clickable
                                            onClick={() => handleSlotClick(slot)}
                                            sx={{
                                                border: '1px solid #4CAF50',
                                                color: isSelected ? 'white' : '#4CAF50',
                                                backgroundColor: isSelected ? '#4CAF50' : 'white',
                                                '&:hover': {
                                                    backgroundColor: isSelected ? '#45a049' : '#f1f1f1',
                                                },
                                            }}
                                        />
                                    );
                                })}
                            </Stack>
                        </CardContent>
                    </Card>
                ))}
            </Stack>

            {/* {bookingPayload && (
                <Paper sx={{ mt: 3, p: 2, bgcolor: '#e0f7fa' }}>
                    <Typography variant="h6">Generated Payload:</Typography>
                    <pre>{JSON.stringify(bookingPayload, null, 2)}</pre>
                </Paper>
            )} */}
        </Box>
    );
};

export default ScheduleViewer;
